import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-teknura-white border-b-2 border-teknura-teal shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-teknura-teal border-2 border-teknura-teal rounded"></div>
            <h1 className="text-2xl font-bold text-teknura-teal">
              TEKNURA.COM
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#home" className="text-teknura-dark hover:text-teknura-teal border-b border-transparent hover:border-teknura-teal transition-colors">
              HOME
            </a>
            <a href="#services" className="text-teknura-dark hover:text-teknura-teal border-b border-transparent hover:border-teknura-teal transition-colors">
              SERVICES
            </a>
            <a href="#about" className="text-teknura-dark hover:text-teknura-teal border-b border-transparent hover:border-teknura-teal transition-colors">
              ABOUT
            </a>
            <a href="#contact" className="text-teknura-dark hover:text-teknura-teal border-b border-transparent hover:border-teknura-teal transition-colors">
              CONTACT
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-teknura-teal border border-teknura-teal px-3 py-1 hover:bg-teknura-teal hover:text-teknura-white transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? 'CLOSE' : 'MENU'}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-teknura-teal pt-4">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-teknura-dark hover:text-teknura-teal border-l-2 border-transparent hover:border-teknura-teal pl-4 transition-colors">
                HOME
              </a>
              <a href="#services" className="text-teknura-dark hover:text-teknura-teal border-l-2 border-transparent hover:border-teknura-teal pl-4 transition-colors">
                SERVICES
              </a>
              <a href="#about" className="text-teknura-dark hover:text-teknura-teal border-l-2 border-transparent hover:border-teknura-teal pl-4 transition-colors">
                ABOUT
              </a>
              <a href="#contact" className="text-teknura-dark hover:text-teknura-teal border-l-2 border-transparent hover:border-teknura-teal pl-4 transition-colors">
                CONTACT
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
